import { combineReducers } from 'redux'
import Auth from './Auth'
import Home from './Home'
import SinglePortfolio from './SinglePortfolio'
import SingleJob from './SingleJob'
import Profile from './Profile';
import userWalkthrough from './userWalkthrough';
import master from './masters';
import iLearn from './Ilearn';
import DETAILS from './JobList'
import NOTIFICATION from './notifcation'
import Story from './Story'
import Declaration from './Declaration'
import Profiler from './Profiler'
// import dataList from "../../redux/reducers/data-list/"
const appReducer = combineReducers({
    Auth,
    Home,
    SinglePortfolio,
    SingleJob,
    Profile,
    userWalkthrough,
    master,
    iLearn,
    DETAILS,
    NOTIFICATION,
    Story,
    Declaration,
      Profiler
})

export const LogOut = () => ({ type: 'RESSET_STORE' })

const rootReducer = (state, action) => {
  
    if (action.type === 'RESSET_STORE') {
        state = {}
        sessionStorage.removeItem('token');
        localStorage.clear();
        window.location.href = `${process.env.PUBLIC_URL}/Career/Home`;
    }
    return appReducer(state, action)
}

export default rootReducer